// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ListSvg from '@rsuite/icon-font/lib/application/List';
var List = createSvgIcon({
  as: ListSvg,
  ariaLabel: 'list',
  category: 'application',
  displayName: 'List'
});
export default List;